import React from "react";
import { Link } from "react-router-dom";
import { popular } from "./data";
function Popular_sidebar(){
    return(
        <div className="popular-posts sidebar-widget">
            <h2>محبوب ترین مقالات</h2>
            {
                popular.map((post)=>{
                    return(
                        <div className="post" key={post.id}>
                            <Link to={`/blog/post/${post.id}`}></Link>
                            <div className="img-box">
                                <img src={post.img} alt={post.title} title={post.title} className="img-fluid" />
                            </div>
                            <div className="info-box">
                                <h3>{post.title}</h3>
                                <p>{post.excerpt}</p>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}

export default Popular_sidebar;